//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 11/09/2024
// Version : 1
// Description : traigo los grupos e items para el checklist
//------Changes -------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../services/apirest";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  Grid,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
} from "@mui/material";
import Agregar_tarea_check from "./Agregar_tarea_check";

function Checklist(props) {
  const [datosTanque, setDatosTanque] = useState(props.datos);
  const [checklist, setChecklist] = useState(props.checklist);
  const [row, setRow] = useState(props.row);
  const [tabla, setTabla] = useState(true);
  const [tarea, setTarea] = useState(false);
  const [tipoSeleccionado, setTipoSeleccionado] = useState(); // Estado para el tipo seleccionado
  const [desplegableTipos, setDesplegableTipos] = useState();
  const [tareasAgregadas, setTareasAgregadas] = useState(
    props.tareasAgregadas || []
  );
  const obtenerTipos = () => {
    fetch(UrlApi + "/tanque_grupos/desplegable")
      .then((data) => data.json())
      .then((data) => setDesplegableTipos(data));
  };
  useEffect(() => {
    obtenerTipos();
  }, []);

  // console.log("TIPOS", desplegableTipos);
  const [datosGruposeItems, setDatosGruposeItems] = useState();

  const obtenerGrupoEitems = () => {
    if (!tipoSeleccionado) return; // Evita la llamada si no hay tipo seleccionado
    fetch(UrlApi + "/tanque_grupos/paraChecklist/" + tipoSeleccionado)
      .then((data) => data.json())
      .then((data) => setDatosGruposeItems(data));
  };

  const handleTipoChange = (event) => {
    setTipoSeleccionado(event.target.value); // Actualiza el tipo seleccionado
  };
  //ejecuta la funcion de obtener
  useEffect(() => {
    obtenerGrupoEitems();
  }, [tipoSeleccionado]);

  useEffect(() => {
    setDatosTanque({
      ...props.datos,
    });
  }, [props.datos]);

  const handleClose = () => {
    setChecklist(!checklist);
    if (props.onClose) {
      props.onClose();
    }
  };

  const gruposConItems = useMemo(() => {
    if (!datosGruposeItems) return [];

    return datosGruposeItems.reduce((acc, item) => {
      const grupoExistente = acc.find(
        (grupo) => grupo.id_grupo === item.id_grupo
      );

      if (grupoExistente) {
        // Si el grupo ya existe, añadimos el item a su lista de items
        grupoExistente.items.push(item);
      } else {
        // Si el grupo no existe, creamos un nuevo grupo con su primer item
        acc.push({
          id_grupo: item.id_grupo,
          nombre_grupo: item.nombre_grupo,
          items: [item],
        });
      }

      return acc;
    }, []);
  }, [datosGruposeItems]);

  const mostrarTarea = (item) => {
    const yaExiste = tareasAgregadas.some((t) => t.id_item === item.id_item);

    if (yaExiste) {
      alert("Esta tarea ya fue generada para este ítem.");
      return;
    }

    setTarea(true);
    setDatosTanque(item);
  };

  const handleCloseTarea = () => {
    setTarea(false);
    setChecklist(false);
    setTabla(true);
    if (props.onClose) {
      props.onClose();
    }
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";
  // console.log("datos tanque check", datosTanque);
  // console.log("row check",row.original);
  return (
    <div>
      <Dialog
        open={checklist}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen
        PaperProps={{
          sx: {
            backgroundColor: "#D4D3CE",
          },
        }}
      >
        <AppBar
          sx={{
            position: "relative",
            background: "#1976d2",
          }}
        >
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            {/* Left Section: Close Icon and Typography */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, fontWeight: "bold" }} variant="h6">
                Generar Tareas por Checklist
              </Typography>
            </Box>

            {/* Center Section: FormControl */}
            <FormControl
              variant="filled"
              size="small"
              sx={{
                minWidth: 200,
                backgroundColor: "white",
                borderRadius: 1,
                mr: 2,
              }}
            >
              <InputLabel id="lbl_estado" sx={{ color: "#333" }}>
                Tipo de checklist
              </InputLabel>
              <Select
                required
                name="tipo"
                label="Tipo"
                labelId="lbl_estado"
                value={tipoSeleccionado || ""}
                onChange={handleTipoChange}
                MenuProps={{
                  PaperProps: {
                    style: {
                      backgroundColor: "white",
                    },
                  },
                }}
                inputProps={{
                  style: { color: "#333" },
                }}
              >
                {desplegableTipos?.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.valor}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Right Section: Close Button */}
            <Button
              onClick={handleClose}
              sx={{
                color: "#fff",
                textTransform: "none",
                fontWeight: "bold",
              }}
            >
              Cerrar
            </Button>
          </Toolbar>
        </AppBar>

        <Grid container spacing={2} sx={{ p: 3 }}>
          {gruposConItems?.length > 0 ? (
            gruposConItems.map((grupo, index) => (
              <Grid item xs={12} key={index}>
                <Box
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    backgroundColor: "#ffffff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    mb: 3,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ mb: 1, color: "#1976d2", fontWeight: "bold" }}
                  >
                    {grupo.nombre_grupo}
                  </Typography>
                  <Divider sx={{ mb: 1 }} />
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#B5B5B3" }}>
                        <TableCell>
                          <strong>Nombre del Ítem</strong>
                        </TableCell>
                        <TableCell>
                          <strong>Definición</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>Acciones</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {grupo.items.map((item, itemIndex) => (
                        <React.Fragment key={itemIndex}>
                          <TableRow hover>
                            <TableCell>{item.nombre_item}</TableCell>
                            <TableCell>{item.definicion_item}</TableCell>
                            <TableCell align="center">
                              <Button
                                variant="contained"
                                size="small"
                                color={
                                  tareasAgregadas?.some(
                                    (t) => t.id_item === item.id_item
                                  )
                                    ? "success"
                                    : "primary"
                                }
                                disabled={tareasAgregadas?.some(
                                  (t) => t.id_item === item.id_item
                                )}
                                onClick={() => mostrarTarea(item)}
                              >
                                {tareasAgregadas?.some(
                                  (t) => t.id_item === item.id_item
                                )
                                  ? "Tarea ya agregada"
                                  : "Agregar Tarea"}
                              </Button>
                            </TableCell>
                          </TableRow>
                          {itemIndex < grupo.items.length - 1 && (
                            <TableRow>
                              <TableCell colSpan={3}></TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Grid>
            ))
          ) : (
            <Typography variant="h6" color="textSecondary" mt={6} ml={10}>
              Seleccione el tipo de checklist primero...
            </Typography>
          )}
        </Grid>
      </Dialog>

      {tarea ? (
        <Agregar_tarea_check
          tarea={tarea}
          tabla={setTabla}
          datos={datosTanque}
          row={row}
          tareasAgregadas={tareasAgregadas}
          onClose={handleCloseTarea}
        />
      ) : null}
    </div>
  );
}

export default Checklist;
